import { createContext, useReducer } from 'react'
import adminReducer from './AdminReducer'

const AdminContext = createContext()

export const AdminProvider = ({ children }) => {
  const initialState = {
    admins: [],
    admin: {},
    overview: {},
    loading: false,
  }

  const [state, dispatch] = useReducer(adminReducer, initialState)

  return (
    <AdminContext.Provider
      value={{
        ...state,
        dispatch,
      }}
    >
      {children}
    </AdminContext.Provider>
  )
}

export default AdminContext
